export default "__VITE_ASSET__DiQZ947u__"